export default __webpack_public_path__ + "logo.66f5ee639e6cf0f133a921608a7a58c9.png";